import styled from "styled-components";

export const ScatterChartBox = styled.div`
  width: 100%;
  height: 100%;

  .echarts-for-react {
    & > div {
      height: 100% !important;
    }
  }
`;
